import { render, staticRenderFns } from "./DraggableTreeviewNode.vue?vue&type=template&id=47d67400&scoped=true&"
import script from "./DraggableTreeviewNode.vue?vue&type=script&lang=ts&"
export * from "./DraggableTreeviewNode.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableTreeviewNode.vue?vue&type=style&index=0&id=47d67400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d67400",
  null
  
)

export default component.exports